import classNames from "classnames";
import { FC, CSSProperties, HTMLAttributes, ReactNode } from "react";

const BannerCard: FC<{ className?: string; children?: ReactNode; rootClassName?: string, rootStyles?:CSSProperties } & HTMLAttributes<HTMLDivElement>> = ({
  rootClassName,
  rootStyles,
  children,
  className,
  ...props
}) => {
  return (
    <div className={classNames("flex w-full items-stretch justify-stretch rounded-none bg-background-primary ps-0.5", rootClassName)} style={rootStyles}>
      <div className={classNames("bg-background-default flex-1", className)} {...props}>{children}</div>
    </div>
  );
};

export default BannerCard;
